module.exports = __webpack_public_path__ + "img/logo.22b56397.svg";